module.exports = __webpack_public_path__ + "img/m_close_button.7e87397e.svg";